<template>
  <div class="ColumnNavigation">
    <div class="navigationBreadWrapper">
      <Breadcrumbs :range="range" />
    </div>
    <div class="navigationContentWrapper">
      <div
        ref="navigationContent"
        :class="{ navigationContent: true, isRoot: routes.length <= 1 }"
        :style="{ left: navigationLeft + 'px' }"
      >
        <div
          class="page"
          v-for="(route, routeIndex) in routes"
          :key="routeIndex"
          :style="{
            left: getColumnLeft(routeIndex) + 'px',
            width: getColumnWidth(routeIndex) + 'px',
          }"
        >
          <component
            :is="route.componentName"
            :index="routeIndex"
            :currentValue="route"
            :prevValue="
              $store.state.navigation.routes[baseIndex + routeIndex - 1]
            "
            :nextValue="
              $store.state.navigation.routes[baseIndex + routeIndex + 1]
            "
            :currentLocal="locals[routeIndex]"
            :prevLocal="locals[routeIndex - 1]"
            :nextLocal="locals[routeIndex + 1]"
            :localActive="routeIndex === localIndex"
            :active="baseIndex + routeIndex === $store.state.navigation.index"
            :enableScroll="true"
          ></component>
        </div>
      </div>
    </div>
    <div
      v-show="canMovePositionBy(-1)"
      class="navigationButton navigationButtonLeft"
      @click.prevent="movePositionBy(-1)"
    >
      <i class="fa fa-chevron-left"></i>
    </div>

    <div
      v-show="canMovePositionBy(1)"
      class="navigationButton navigationButtonRight"
      @click.prevent="movePositionBy(1)"
    >
      <font-awesome-icon icon="chevron-right" />
    </div>
  </div>
</template>

<script>
import Component, { mixins } from 'vue-class-component';
import NavigationMixin from '@/mixins/NavigationMixin';

@Component({})
export default class ColumnNavigation extends mixins(NavigationMixin) {}
</script>
<style lang="scss" scoped>
.ColumnNavigation {
  position: relative;
  flex: 1;
  box-sizing: border-box;
  height: 100%;
}

.navigationBreadWrapper {
}

.navigationTitleWrapper {
  padding: 10px 20px;
  .navigationTitle {
    padding-bottom: 10px;
    vertical-align: middle;
    color: #000;
    font-size: 18px;
    font-weight: bold;
    border-bottom: solid 2px #0057b8;
  }
}

.navigationContentWrapper {
  position: absolute;
  top: 60px;
  bottom: 0;
  width: calc(100% - 36px);
  margin: 0 18px;
  overflow: hidden;
}
.navigationContent {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  transition: left 0.5s;
}
.page {
  position: absolute;
  top: 0;
  bottom: 0;
  box-sizing: border-box;
}
.navigationButton {
  position: absolute;
  top: 0;
  bottom: 0;
  height: 20px;
  margin-top: auto;
  margin-bottom: auto;
  font-size: 20px;
  cursor: pointer;
  &.navigationButtonLeft {
    left: 0;
  }
  &.navigationButtonRight {
    right: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ColumnNavigation.vue